import LoginInformation from './LoginInformation.page';

export default LoginInformation;